import React from "react";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";

class Page7 extends React.Component {
  state = {
    visible: true,
    question: "",
    showForm: false,
    questionAnswer: null,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 7) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }

  saveAnswerChange = (event) => {
    this.setState({ questionAnswer: event.target.value });

    if (
      this.state.question ==
      "What does this tell you about your future career direction?"
    ) {
      this.props.updatePdf(
        "Yes",
        this.state.question,
        this.state.questionAnswer
      );
    } else if (
      this.state.question ==
      "What types of jobs do you think will harness your strengths?"
    ) {
      this.props.updatePdf(
        "No",
        this.state.question,
        this.state.questionAnswer
      );
    }
  };

  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav py-0 ">
                <li className="nav-item py-0 ">
                  <h3 className="py-0  d-md-block">Reflective Questions</h3>
                </li>
              </ul>
            </nav>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex">
                        <div className="p-2" id="moduleContentText">
                          Are you or have you been using your strengths at
                          University, work or in your extra-curricular
                          activities?
                        </div>
                        <div className="ml-auto p-2">
                          <ToggleButtonGroup type="radio" name="options">
                            <ToggleButton
                              value={1}
                              onClick={() =>
                                this.setState({
                                  showForm: true,
                                  question:
                                    "What does this tell you about your future career direction?",
                                })
                              }
                            >
                              Yes
                            </ToggleButton>
                            <ToggleButton
                              value={2}
                              onClick={() =>
                                this.setState({
                                  showForm: true,
                                  question:
                                    "What types of jobs do you think will harness your strengths?",
                                })
                              }
                            >
                              No
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item form-card-2">
                      <div className="d-flex">
                        <div className="p-2" id="moduleContentText">
                          {this.state.question}
                        </div>
                      </div>
                      <div className="d-flex flex-column bd-highlight mb-3">
                        {this.state.showForm ? (
                          <div className="form-group">
                            <textarea
                              className="form-control "
                              id="exampleFormControlTextarea1"
                              placeholder="Enter your answer here..."
                              rows="20"
                              value={this.state.questionAnswer}
                              onChange={this.saveAnswerChange}
                            ></textarea>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page7;
